import { ColorName } from '@lbcamden/lib-react';
import { parseDate } from '@lbcamden/shared-utils';
import { DateTime } from 'luxon';

import { isProd } from '~/client/config/appConfig';
import { RpeepStatus } from '~/common/types/people';
import { ResidentRecord } from '~/common/types/residentsReport';

let staleTimeMins = 90;

// For testing purposes
if (!isProd) {
  window.setArrrStaleTime = (mins: number) => {
    staleTimeMins = mins;
  };
}

export const checkHasStaleData = (results: ResidentRecord[]) => {
  const staleThreshold = DateTime.now().minus({ minutes: staleTimeMins });

  return results.some((record) => parseDate(record.modified) < staleThreshold);
};

export const getReviewDateTextColour = (reviewDate?: Date): ColorName | undefined => {
  if (!reviewDate) {
    return undefined;
  }
  const now = DateTime.now();
  const nowPlus60Days = now.plus({ days: 60 });
  const parsedReviewDate = parseDate(reviewDate);

  if (parsedReviewDate <= now) {
    return 'error';
  }
  return parsedReviewDate <= nowPlus60Days ? 'warning' : 'text';
};

export const getRpeepStatusColour = (status?: RpeepStatus): ColorName => {
  switch (status) {
    case RpeepStatus.Active:
      return 'success';
    case RpeepStatus.Revoked:
      return 'error';
    default:
      return 'text';
  }
};
